<button class="black-button" (click)="blackButtonClicked(routePath)">
    {{title}}
</button>